module.exports = __webpack_public_path__ + "img/cart_title_bg.6799185d.jpeg";